import React from 'react';

import styles from './styles.module.scss';
import {Social} from '../../../components/Social';
import {reviews} from './data';
import {Check} from '../../../assets';

export const Community = () => {
  return (
    <div className={styles.community}>
      <h3 className={styles.title}>Join Our Vibrant Community</h3>
      <div className={styles.socialWrapper}>
        <Social />
      </div>
      <div className={styles.reviewsWrapper}>
        {reviews.map((review) => {
          return <Review review={review} key={review.id} />;
        })}
        <div className={styles.reviewsWrapperDecor}></div>
      </div>
    </div>
  );
};

const Review = ({review}) => {
  return (
    <div className={styles.review} key={review.id}>
      <div className={styles.top}>
        <div className={styles.avatar}>
          <img src={review.avatar} alt={review.name} />
        </div>
        <div className={styles.content}>
          <p className={styles.name}>
            {review.name}
            {review.check && <Check />}
          </p>
          <p className={styles.text}>{review.link}</p>
        </div>
      </div>
      {review.text.map((text, index) => (
        <p className={styles.text} key={index}>
          {text}
        </p>
      ))}
    </div>
  );
};
